import apiClient from "./axiosInstance"

export const TAdoVisibleCampaign = async (id: string, visibility: string) => {
  const query = new URLSearchParams({
    id,
    visibility,
  })

  const response = await apiClient.post(`/admin/campaign/visible?${query}`, {}, {})

  if (response.status === 200) {
    return response
  }
}

export const TAfindCampaign = async (data: { name?: string }) => {
  let query = ""
  if (data.name) {
    query = `?name=${data.name}`
  }

  const response = await apiClient.get(`/admin/campaign/get${query}`, {})

  if (response.status === 200) {
    return response
  } else {
    throw new Error("Find Campaign failed")
  }
}

export const TAfindApprovedCampaigns = async (page: number, perPage: number) => {
  const response = await apiClient.get(
    `/admin/campaign/getverifiedcampaign?page=${page}&perPage=${perPage}`,
    {},
  )
  if (response.status === 200) {
    return response.data
  } else {
    throw new Error("Find Campaign failed")
  }
}

export const TAfindCampaignById = async (_id: string) => {
  const response = await apiClient.get(`/admin/campaign/_id/${_id}`, {})
  if (response.status === 200) {
    return response.data
  } else {
    throw new Error("Find User failed")
  }
}

export const TAgetCampaignApplicationTime = async (
  start?: string,
  end?: string,
  groupBy: "day" | "week" | "month" = "day",
  campaignIds?: string[],
  signal?: AbortSignal,
) => {
  const params: Record<string, unknown> = {}
  if (start) {
    params.start = start
  }
  if (end) {
    params.end = end
  }
  if (groupBy) {
    params.groupBy = groupBy
  }
  if (campaignIds && campaignIds.length > 0) {
    params.campaign = campaignIds.join(",")
  }

  const response = await apiClient.get("/admin/campaign/campaign-application-time", {
    params,
    signal,
  })
  if (response.status === 200) {
    return response.data
  } else {
    throw new Error("Campaign application time data not found")
  }
}

export const TAsetVisibility = async (_id: string, status: boolean) => {
  const response = await apiClient.get(
    `/admin/campaign/set-visibilty?status=${status}&_id=${_id}`,
    {},
  )
  if (response.status === 200) {
    return response.data
  } else {
    throw new Error("Find Campaign failed")
  }
}

export const TAfindAllCampaigns = async (
  created_at_start: string,
  created_at_end: string,
  country: string,
  platform: string,
  step: string,
  visibility: string,
  max_cost: string,
  gender: string,
  barter: string,
  deleted: string,
  min_follower: string,
  max_follower: string,
  min_age: string,
  max_age: string,
  sortBy: string,
  sortOrder: boolean,
  page: number,
  perPage: number,
  campaign: string,
  classification: string,
  signal?: AbortSignal,
) => {
  const response = await apiClient.get(
    `/admin/campaign/getall?created_at_start=${encodeURIComponent(
      created_at_start,
    )}&created_at_end=${encodeURIComponent(created_at_end)}&country=${encodeURIComponent(
      country,
    )}&platform=${encodeURIComponent(platform)}&step=${encodeURIComponent(
      step,
    )}&visibility=${encodeURIComponent(visibility)}&max_cost=${encodeURIComponent(
      max_cost,
    )}&gender=${encodeURIComponent(gender)}&barter=${encodeURIComponent(
      barter,
    )}&deleted=${encodeURIComponent(deleted)}&min_follower=${encodeURIComponent(
      min_follower,
    )}&max_follower=${encodeURIComponent(max_follower)}&min_age=${encodeURIComponent(
      min_age,
    )}&max_age=${encodeURIComponent(max_age)}&sortBy=${encodeURIComponent(
      sortBy,
    )}&sortOrder=${encodeURIComponent(sortOrder)}&page=${encodeURIComponent(
      page,
    )}&perPage=${encodeURIComponent(perPage)}&campaign=${encodeURIComponent(
      campaign,
    )}&classification=${encodeURIComponent(classification)}`,
    { signal },
  )

  if (response.status === 200) {
    return response.data
  } else {
    throw new Error("Find Campaign failed")
  }
}

export const TAfindApprovalCampaign = async () => {
  const response = await apiClient.get("/admin/campaign/getverificationcampaign", {})

  if (response.status === 200) {
    return response.data
  } else {
    throw new Error("Find Campaign failed")
  }
}

export const TAdoApprovalCampaign = async (status: string, rejected_reason: string, id: string) => {
  const query = new URLSearchParams({
    id,
    status,
    rejected_reason,
  })

  const response = await apiClient.post(`/admin/campaign/verificate?${query}`)

  if (response.status === 200) {
    return response.data
  } else {
    throw new Error("Approval Campaign failed")
  }
}

export const TAupdateNote = async (id: string, author: string, note: string) => {
  const response = await apiClient.put(
    `/admin/campaign/update-note/${id}`,
    { author, note },
    {
      headers: {
        "Content-Type": "application/json",
      },
    },
  )
  if (response.status === 200) {
    return response.data
  } else {
    throw new Error("Update Campaign note failed")
  }
}

export const TAdeleteNote = async (id: string, noteIndex: number) => {
  const response = await apiClient.delete(`/admin/campaign/delete-note/${id}`, {
    data: { noteIndex },
    headers: {
      "Content-Type": "application/json",
    },
  })
  if (response.status === 200) {
    return response.data
  } else {
    throw new Error("Delete Campaign note failed")
  }
}

export const TAupdateCampaignNotes = async (id: string, notes: string[]) => {
  const response = await apiClient.put(`/admin/campaign/updatenote/${id}`, { notes })
  if (response.status === 200) {
    return response.data
  } else {
    throw new Error("Update Campaign notes failed")
  }
}

export const TAsendVoiceMessage = async (campaignId: string, state: string, type: string) => {
  const response = await apiClient.post("/admin/campaign/send-voice-message/", {
    campaignId,
    state,
    type,
  })
  if (response.status === 200) {
    return response.data
  } else {
    throw new Error("Send Voice Message failed")
  }
}

export const TAgetVoiceMessageInfo = async (campaignId: string, state: string, type: string) => {
  const response = await apiClient.get("/admin/campaign/get-voice-message-info", {
    params: { campaignId, state, type },
  })
  if (response.status === 200) {
    return response.data
  } else {
    throw new Error("Get Voice Message Info failed")
  }
}

export const TAsendSMS = async (campaignId: string) => {
  const response = await apiClient.post("/admin/campaign/send-sms", {
    campaignId,
  })
  if (response.status === 200) {
    return response.data
  } else {
    throw new Error("Send SMS failed")
  }
}

export const TAgetSMSInfo = async (campaignId: string) => {
  const response = await apiClient.get("/admin/campaign/get-sms-info", {
    params: { campaignId },
  })
  if (response.status === 200) {
    return response.data
  } else {
    throw new Error("Get SMS Info failed")
  }
}

export const TAsendEmail = async (campaignId: string) => {
  const response = await apiClient.post("/admin/campaign/send-email", {
    campaignId,
  })
  if (response.status === 200) {
    return response.data
  } else {
    throw new Error("Send Email failed")
  }
}

export const TAgetEmailInfo = async (campaignId: string) => {
  const response = await apiClient.get("/admin/campaign/get-email-info", {
    params: { campaignId },
  })
  if (response.status === 200) {
    return response.data
  } else {
    throw new Error("Get Email Info failed")
  }
}

export const TAsendWhatsappMessage = async (campaignId: string) => {
  const response = await apiClient.post("/admin/campaign/send-whatsapp-message", {
    campaignId,
  })
  if (response.status === 200) {
    return response.data
  } else {
    throw new Error("Send Whatsapp Message failed")
  }
}

export const TAgetWhatsappMessageInfo = async (campaignId: string) => {
  const response = await apiClient.get("/admin/campaign/get-whatsapp-message-info", {
    params: { campaignId },
  })
  if (response.status === 200) {
    return response.data
  } else {
    throw new Error("Get Whatsapp Message Info failed")
  }
}

export const TAupdateClassification = async (id: string, classification: string) => {
  const response = await apiClient.post("/admin/campaign/set-campaign-classification", {
    campaignId: id,
    classification,
  })
  if (response.status === 200) {
    return response.data
  } else {
    throw new Error("Update Campaign classification failed")
  }
}

export const TAupdateCampaign = async (id: string, data: Record<string, unknown>) => {
  const response = await apiClient.put(`/admin/campaign/updatecampaign/${id}`, data, {
    headers: {
      "Content-Type": "application/json",
    },
  })

  if (response.status === 200) {
    return response.data
  } else {
    throw new Error("Approval Campaign failed")
  }
}

export const TAupdateCampaignLogo = async (id: string, file: File | FormData) => {
  const formData = file instanceof FormData ? file : new FormData()

  if (!(file instanceof FormData)) {
    formData.append("cover_photo", file)
  }

  return apiClient.put(`/admin/campaign/updatecoverphoto/${id}`, formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  })
}

export const TAcampaignLimitationApplications = async (
  id: string,
  page: number,
  perPage: number,
) => {
  const response = await apiClient.get(
    `/admin/campaign/suggested-users?campaignId=${id}&page=${page}&perPage=${perPage}`,
    {
      headers: {
        "Content-Type":
          "multipart/form-data; boundary=<calculated when request is sent></calculated>",
      },
    },
  )

  return response
}

export const TAstateCounts = async (campaignIds: string[]) => {
  const response = await apiClient.post("/admin/campaign/state-counts", campaignIds, {
    headers: {
      "Content-Type": "application/json",
    },
  })

  if (response.status === 200) {
    return response.data
  } else {
    throw new Error("Approval Campaign failed")
  }
}

export const TAcalledCounts = async (campaignIds: string[]) => {
  const response = await apiClient.post("/admin/campaign/called-counts", campaignIds, {
    headers: {
      "Content-Type": "application/json",
    },
  })

  if (response.status === 200) {
    return response.data
  } else {
    throw new Error("Approval Campaign failed")
  }
}

export const TAvoiceMessageCounts = async (campaignIds: string[]) => {
  const response = await apiClient.post("/admin/campaign/voice-message-counts", campaignIds, {
    headers: {
      "Content-Type": "application/json",
    },
  })

  if (response.status === 200) {
    return response.data
  } else {
    throw new Error("Approval Campaign failed")
  }
}

export const TAcampaignNames = async (name: string) => {
  const response = await apiClient.get(`/admin/campaign/get-campaign-names?name=${name}`)

  if (response.status === 200) {
    return response.data
  } else {
    throw new Error("Approval Campaign failed")
  }
}

export const TAuploadExcelFile = async (campaignId: string, file: File, uploadedBy: string) => {
  const formData = new FormData()
  formData.append("file", file)
  formData.append("uploadedBy", uploadedBy)

  const response = await apiClient.post(`/admin/campaign/upload-excel/${campaignId}`, formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  })

  if (response.status === 200) {
    return response.data
  } else {
    throw new Error("Excel upload failed")
  }
}

export const TAgetExcelUploads = async (campaignId: string) => {
  const response = await apiClient.get(`/admin/campaign/excel-uploads/${campaignId}`)

  if (response.status === 200) {
    return response.data
  } else {
    throw new Error("Failed to get Excel uploads")
  }
}

export const TAupdateExcelUploadStatus = async (
  campaignId: string,
  uploadId: string,
  status: "completed" | "failed",
  successCount: number,
  failureCount: number,
  errorMessages: string[],
) => {
  const response = await apiClient.put(
    `/admin/campaign/update-excel-upload-status/${campaignId}/${uploadId}`,
    {
      status,
      successCount,
      failureCount,
      errorMessages,
    },
    {
      headers: {
        "Content-Type": "application/json",
      },
    },
  )

  if (response.status === 200) {
    return response.data
  } else {
    throw new Error("Failed to update Excel upload status")
  }
}

export const TAdownloadOriginalExcel = async (campaignId: string, uploadId: string) => {
  const response = await apiClient.get(
    `/admin/campaign/download-original-excel/${campaignId}/${uploadId}`,
    {
      responseType: "blob",
    },
  )

  if (response.status === 200) {
    return response.data
  } else {
    throw new Error("Failed to download original Excel file")
  }
}

export const TAchangeDeleteStatus = async (campaignId: string, status: boolean) => {
  const response = await apiClient.post("/admin/campaign/change-delete-status", {
    campaignId,
    status,
  })

  if (response.status === 200) {
    return response.data
  } else {
    throw new Error("Failed to change delete status")
  }
}

export const TAsendOnesignalNotification = async (campaignId: string) => {
  const response = await apiClient.post("/admin/campaign/send-onesignal-notification", {
    campaignId,
  })
  if (response.status === 200) {
    return response.data
  } else {
    throw new Error("Send OneSignal Notification failed")
  }
}

export const TAgetOnesignalNotificationInfo = async (campaignId: string) => {
  const response = await apiClient.get("/admin/campaign/get-onesignal-notification-info", {
    params: { campaignId },
  })
  if (response.status === 200) {
    return response.data
  } else {
    throw new Error("Get OneSignal Notification Info failed")
  }
}
